<main>
    <form [formGroup]="form" [class.form-hide2]="minhavariaevl==1">
        <img class="logo-premocenter" src="../../assets/logo-premocenter-vert.png">
        <div class="form">
            <label for="email">
                <span>Email:</span>
                <input type="email" formControlName="vc_login" name="email" id="email" placeholder="ex.: usuario@email.com">
            </label>
            <label for="senha">
                <span>Senha:</span>
                <div class="campo-senha">
                    <input [type]="mostrarSenha ? 'text' : 'password'" formControlName="vc_senha" name="senha"
                        id="senha" class="input-senha">
                    <span class="icone-olho" role="button" aria-label="Pressione para mostrar a senha"
                        (mousedown)="mostrarSenha = true" (mouseup)="mostrarSenha = false"
                        (mouseleave)="mostrarSenha = false" (touchstart)="mostrarSenha = true"
                        (touchend)="mostrarSenha = false" (touchcancel)="mostrarSenha = false">
                        <svg *ngIf="!mostrarSenha" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        <svg *ngIf="mostrarSenha" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M9.9 4.24A9.6 9.6 0 0 1 12 4C19 4 23 12 23 12A18.5 18.5 0 0 1 19.5 16.5M6.5 6.5C3.6 8.4 1 12 1 12C1 12 5 20 12 20A9.3 9.3 0 0 0 15.5 19.4">
                            </path>
                            <path d="M10.6 10.6A3 3 0 0 0 13.4 13.4"></path>
                            <path d="M3 3L21 21"></path>
                        </svg>
                    </span>
                </div>
            </label>
            <div *ngIf="senhaInvalida > 2">
                <re-captcha (resolved)="resolved($event)" (error)="errored($event)" errorMode="handled" id="recaptcha"
                    name="recaptcha" formControlName="recaptcha" required></re-captcha>
            </div>
        </div>
        <p class="msg-erro"> {{mensagem}}</p>
        <div class="w-100 d-flex justify-content-center align-items-center flex-column">
            <button class="btn btn-success w-50 mt-1" [disabled]="desabilitaBotao" (click)="onSubmit()">
                <ng-container *ngIf="!desabilitaBotao; else load">Entrar</ng-container>
                <ng-template #load><mat-progress-spinner diameter=25 class="example-margin" color="primary" mode="indeterminate"
                        value="50"> </mat-progress-spinner></ng-template>
                </button>
                <a class="mt-1 link" routerLink="/nova-senha">Esqueceu sua senha?</a>
                <div class="w-100 d-flex justify-content-center align-items-center flex-column mt-1 mb-2">
                    <span class="txt-redirect">Ou entrar com</span>
                    <button class="btn btn-azure ml-1 mt-2 w-50 d-flex justify-content-center" (click)="loginAzure()">
                        <img class="logo-azure mr-2" *ngIf="!desabilitaBotaoAzure; else null" src="../../assets/azure-icon.png" alt="">
                        <ng-container class="txt-azure" *ngIf="!desabilitaBotaoAzure; else loadAzure">Entrar com Azure</ng-container>
                        <ng-template #loadAzure><mat-progress-spinner diameter=25 class="example-margin" color="primary" mode="indeterminate"
                                value="50"> </mat-progress-spinner></ng-template>
                    </button>
                </div>
        </div>
    </form>
    <p class="politica mt-1">Ao acessar você concorda com a <a
            href="https://www.grupoagtech.com/politicas-do-site/">Política de Privacidade</a></p>
            <img class="logo-agtech" src="../../assets/logo-completo-letras-coloridas.png" alt="">

